import Vue from 'vue'
import Vuex from 'vuex'


import {getUserStore} from '@milkboxltd/common-components-frontend';
import alert from './alert'
import cards from './cards';
import payments from './payments';

Vue.use(Vuex)

// eslint-disable-next-line no-undef
const projectName = process.env.VUE_APP_PROJECT_NAME || 'backoffice'
const user = getUserStore(`${process.env.VUE_APP_API_URL || ''}/api/v1`, projectName)

export default new Vuex.Store({
  state: {
    firstName: '',
    lastName: '',
  },
  modules: {
    user,
    alert,
    cards,
    payments,
  }
})
